export default function contactInit() {
	initSubmitContactForm();

	const contactContainer = document.querySelector("[data-select='modalContainer']");
	const contactModalBtn = document.querySelector("[data-select='contactModalBtn']");
	const contactCloseBox = document.querySelector("[data-select='contactCloseBox']")

	if (contactContainer) {
		contactContainer.addEventListener("click", function(e) {
			if (e.target === contactContainer) {
				contactContainer.classList.remove("contactGrid");
			}
		});
	}

	if (contactModalBtn) {
		contactModalBtn.addEventListener("click", function() {
			contactContainer.classList.add("contactGrid");
		});
	}

	if (contactCloseBox) {
		contactCloseBox.addEventListener("click", function() {
			contactContainer.classList.remove("contactGrid");
		});
	}
}

function initSubmitContactForm() {
	const formElement = document.querySelector("#contactForm");

	if (formElement) {
		if (formElement.addEventListener) {
			formElement.addEventListener("submit", function (e) {
				e.preventDefault();

				const endpointUri = formElement.getAttribute('action');
				const identifier = formElement.querySelector("[name='command[offerIdentifier]']").value;
				const message = formElement.querySelector("[name='command[message]']").value;

				const container = document.querySelector("#contactInfoContainer");
				const confirm = document.querySelector("#confirmationMsg");
				const error = document.querySelector("#errorMsg");

				const submitData = new FormData(formElement);
				submitData.append("command[offerIdentifier]", identifier);
				submitData.append("command[message]", message);

				const xhttp = new XMLHttpRequest();
				xhttp.onload = function() {
					if (this.status === 200) {
						confirm.classList.remove("hiddenResponseMessage");
						container.classList.add("hiddenResponseMessage");
						error.classList.add("hiddenResponseMessage");
					} else {
						error.classList.remove("hiddenResponseMessage");
						confirm.classList.add("hiddenResponseMessage");
					}
				}
				xhttp.open("POST", endpointUri);
				xhttp.send(submitData);
			}, false);
		}
	}
}

contactInit();
